// Copyright ©️ 2026 eVolve MEP, LLC

import type { WorkOrderPaginated } from '@evolvemep/api-ts';

import { EntityStatusBadge } from 'components/Mantine/EntityStatusBadge';
import { SelectableCard } from 'components/Mantine/Navigation/SelectableCard';

type Props = {
  workOrder: WorkOrderPaginated;
};

export const SelectableWorkOrderCard = ({ workOrder }: Props) => (
  <SelectableCard
    from="Work Orders"
    to={`/work-orders/${workOrder.workOrderId}`}
    title={workOrder.name}
    description={workOrder.identifier}
    rightSection={
      <EntityStatusBadge
        customStatusEntityName="Work Order"
        stateName={workOrder.workOrderStateName}
        statusId={workOrder.workOrderStatusId}
      />
    }
  />
);
